import { i18n } from '@/locale';
import { isEmpty, isString } from '../is';

export function parseI18nTemplate(template, dict) {
  return template.replace(/\{([^}]+)\}/g, (match, key) => dict[key] || match);
}

export function wrapChineseCharsWithBraces(inputString) {
  // 使用正则表达式匹配中文字符
  const regex = /[\u4e00-\u9fa5]+/g;

  const list = [];

  // 使用replace方法替换匹配到的中文字符，将它们用花括号包起来
  const template = inputString.replace(regex, match => {
    list.push(match);
    return `{${match}}`;
  });

  return { template, list };
}

export function translateTo(text, _path, option = {}) {
  let dict = i18n.messages[i18n.locale];

  if (isEmpty(text) || !isString(text)) return text;

  if (dict[text] && isEmpty(option)) return dict[text];

  const { template, list } = wrapChineseCharsWithBraces(text);

  let res = template;
  const record = [];

  // 没有需要翻译的字段
  if (!isEmpty(list)) {
    list.forEach(item => {
      const text = dict[item];

      if (isEmpty(text)) {
        record.push(item);
      } else {
        res = res.replace(`{${item}}`, text);
      }
    });
  }

  res = parseI18nTemplate(res, Object.assign({}, dict, option));

  if (!isEmpty(record)) {
    const { loss, inOpts } = record.reduce(
      (map, e) => {
        if (!(e in option)) {
          map.loss.push(e);
        } else {
          map.inOpts.push(e);
        }

        return map;
      },
      { loss: [], inOpts: [] }
    );

    const optStr = isEmpty(inOpts) ? '' : `, [${inOpts.join(',')}] 在Option中`;

    console.warn(`[i18n] 未找到[${loss.join(',')}]${optStr}`);

    return text;
  }

  return res;
}

export function translateTo2(text, path, option = {}) {
  let dict;

  if (isString(path)) {
    dict = i18n.t(path);
  } else {
    dict = path;
  }

  if (isEmpty(text) || !isString(text)) return text;

  if (isEmpty(dict) && isEmpty(option)) {
    if (isString(path)) {
      console.warn(`[i18n] 未找到路径（${path}.${text}）内容`);
    } else {
      console.warn(`[i18n] dict和option为空, 返回原字符串${text}`);
    }

    return text;
  }

  const { template, list } = wrapChineseCharsWithBraces(text);

  let res = template;
  const record = [];

  // 没有需要翻译的字段
  if (!isEmpty(list)) {
    list.forEach(item => {
      const text = dict[item];

      if (isEmpty(text)) {
        record.push(item);
      } else {
        res = res.replace(`{${item}}`, text);
      }
    });
  }

  res = parseI18nTemplate(res, Object.assign({}, dict, option));

  if (!isEmpty(record)) {
    const { loss, inOpts } = record.reduce(
      (map, e) => {
        if (!(e in option)) {
          map.loss.push(e);
        } else {
          map.inOpts.push(e);
        }

        return map;
      },
      { loss: [], inOpts: [] }
    );

    const optStr = isEmpty(inOpts) ? '' : `, [${inOpts.join(',')}] 在Option中`;

    console.warn(`[i18n] 在路径（${path}）中未找到[${loss.join(',')}]${optStr}`);

    return text;
  }

  return res;
}
